import { updateObject } from '../utility/utility';

const actions = {
  BACKDROP_TOGGLE: (state, action) => updateObject(state, { showBkDrop: action.state }),
  SET_SIDEBAR_STATE: (state, action) => updateObject(state, { sidebarState: action.state }),
};

const initialState = {
  showBkDrop: false,
  sidebarState: false,
};

export default (state = initialState, action) => {
  try {
    return actions[action.type](state, action);
  } catch (e) {
    return state;
  }
};
